import {
  createPaymentLinkService,
  getPaymentLinksService,
  getPaymentLinkDetailsService,
  updatePaymentLinkService,
  togglePaymentLinkService,
  getPaymentLinkActivitiesService,
  getPaymentLinkTransactionsService
} from '@/services/paymentLinkService'
import {
  SortTimeHandler,
  sortAmountHandlerWithDoubleParams,
  SortNameHandler
} from '@/utils/helpers'
// mutation types
const set_createdPaymentLinkDetails = 'set_createdPaymentLinkDetails'
const set_updatedPaymentLinkDetails = 'set_updatedPaymentLinkDetails'
const set_paymentLinks = 'set_paymentLinks'
const set_currentPaymentLinkId = 'set_currentPaymentLinkId'
const set_currentPaymentLinkDetails = 'set_currentPaymentLinkDetails'
const set_paymentLinkActivities = 'set_paymentLinkActivities'
const set_paymentLinkTransactions = 'set_paymentLinkTransactions'
const set_paymentLinkFilter = 'set_paymentLinkFilter'
const sort_paymentLinkTimeData = 'sort_paymentLinkTimeData'
const sort_paymentLinkAmountData = 'sort_paymentLinkAmountData'
const sort_paymentLinkNameData = 'sort_paymentLinkNameData'
// state
const getDefaultState = () => {
  return {
    createdPaymentLinkDetails: null,
    updatedPaymentLinkDetails: {},
    paymentLinks: {
      items: [],
      page: {}
    },
    currentPaymentLinkId: '',
    currentPaymentLinkDetails: {},
    paymentLinkActivities: [],
    paymentLinkTransactions: [],
    paymentLinkFilter: null
  }
}
const state = getDefaultState()

// getters
const getters = {}
// mutations
const mutations = {
  resetState (state) {
    Object.assign(state, getDefaultState())
  },
  [set_createdPaymentLinkDetails] (state, data) {
    state.createdPaymentLinkDetails = data
  },
  [set_updatedPaymentLinkDetails] (state, data) {
    state.updatedPaymentLinkDetails = data
  },
  [set_paymentLinks] (state, data) {
    state.paymentLinks = data
  },
  [set_currentPaymentLinkId] (state, data) {
    state.currentPaymentLinkId = data
  },
  [set_currentPaymentLinkDetails] (state, data) {
    state.currentPaymentLinkDetails = data
  },
  [set_paymentLinkFilter] (state, data) {
    state.paymentLinkFilter = data
  },
  [set_paymentLinkActivities] (state, data) {
    state.paymentLinkActivities = data
  },
  [set_paymentLinkTransactions] (state, data) {
    state.paymentLinkTransactions = data
  },
  [sort_paymentLinkTimeData] (state, sortDirection) {
    state.paymentLinks.items = SortTimeHandler(
      state.paymentLinks.items,
      'createdAt',
      sortDirection
    )
  },
  [sort_paymentLinkAmountData] (state, sortDirection) {
    state.paymentLinks.items = sortAmountHandlerWithDoubleParams(
      state.paymentLinks.items,
      sortDirection
    )
  },
  [sort_paymentLinkNameData] (state, sortDirection) {
    state.paymentLinks.items = SortNameHandler(
      state.paymentLinks.items,
      'title',
      sortDirection
    )
  }
}

// actions
const actions = {
  createPaymentLink: ({ commit }, payload) => {
    return createPaymentLinkService(payload).then((response) =>
      commit('set_createdPaymentLinkDetails', response.data.data)
    )
  },
  updatePaymentLink: ({ commit }, args) => {
    return updatePaymentLinkService(args.payload, args.id).then((response) =>
      commit('set_updatedPaymentLinkDetails', response.data.data)
    )
  },
  getPaymentLinks: ({ commit }, payload) => {
    return getPaymentLinksService(payload).then((response) =>
      commit('set_paymentLinks', response.data.data)
    )
  },
  getPaymentLinkDetails: ({ commit }, payload) => {
    return getPaymentLinkDetailsService(payload).then((response) =>
      commit('set_currentPaymentLinkDetails', response.data.data)
    )
  },
  togglePaymentLinkStatus: ({ commit }, id) => {
    return togglePaymentLinkService(id)
  },
  setCurrentPaymentLinkId: ({ commit }, payload) => {
    commit('set_currentPaymentLinkId', payload)
  },
  getPaymentLinkActivities: ({ commit }, payload) => {
    return getPaymentLinkActivitiesService(payload).then((response) =>
      commit('set_paymentLinkActivities', response.data.data)
    )
  },
  getPaymentLinkTransactions: ({ commit }, payload) => {
    return getPaymentLinkTransactionsService(payload).then((response) =>
      commit('set_paymentLinkTransactions', response.data.data)
    )
  },
  setCreatedPaymentLinkDetails: ({ commit }, payload) => {
    commit('set_createdPaymentLinkDetails', payload)
  },
  setCurrentPaymentLinkDetails: ({ commit }, payload) => {
    commit('set_currentPaymentLinkDetails', payload)
  },
  setPaymentLinkFilter: ({ commit }, payload) => {
    commit('set_paymentLinkFilter', payload)
  },
  sortTimeHandler: ({ commit }, sortDirection) => {
    commit('sort_paymentLinkTimeData', sortDirection)
  },
  sortAmountHandler: ({ commit }, sortDirection) => {
    commit('sort_paymentLinkAmountData', sortDirection)
  },
  sortNameHandler: ({ commit }, sortDirection) => {
    commit('sort_paymentLinkNameData', sortDirection)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
